// Variables
export const PRIMARY_COLOR = "palevioletred";
export const SECONDARY_COLOR = "papayawhip";
// Export
export { default as Title } from './Title';
export { default as Wrapper } from './Wrapper';
export { default as Input } from './Input';
export { default as App } from './App';
export { default as Button } from './Button';


// WEBPACK FOOTER //
// ./src/components/index.js